import React, { useState } from 'react';
function Shared100toGPA() {
    const [originalPercentage, setOriginalPercentage] = useState('');
    const [convertedGPA, setConvertedGPA] = useState('');
    const [showResult, setShowResult] = useState(false);
    const [error, setError] = useState(null);
    const handleCalculateClick = () => {
        const percentage = parseFloat(originalPercentage);
        if (!isNaN(percentage) && percentage >= 60 && percentage <= 100) {
            let calculatedGPA = '';
            if (percentage >= 100) {
                calculatedGPA = '3.97 ~ 4.0';
            } else if (percentage >= 99) {
                calculatedGPA = '3.92 ~ 3.96';
            } else if (percentage >= 98) {
                calculatedGPA = '3.88 ~ 3.91';
            } else if (percentage >= 97) {
                calculatedGPA = '3.84 ~ 3.87';
            } else if (percentage >= 96) {
                calculatedGPA = '3.80 ~ 3.83';
            } else if (percentage >= 95) {
                calculatedGPA = '3.75 ~ 3.79';
            } else if (percentage >= 94) {
                calculatedGPA = '3.71 ~ 3.74';
            } else if (percentage >= 93) {
                calculatedGPA = '3.67 ~ 3.70';
            } else if (percentage >= 92) {
                calculatedGPA = '3.62 ~ 3.66';
            } else if (percentage >= 91) {
                calculatedGPA = '3.58 ~ 3.61';
            } else if (percentage >= 90) {
                calculatedGPA = '3.49 ~ 3.57';
            } else if (percentage >= 89) {
                calculatedGPA = '3.41 ~ 3.48';
            } else if (percentage >= 88) {
                calculatedGPA = '3.32 ~ 3.40';
            } else if (percentage >= 87) {
                calculatedGPA = '3.24 ~ 3.31';
            } else if (percentage >= 86) {
                calculatedGPA = '3.15 ~ 3.23';
            } else if (percentage >= 85) {
                calculatedGPA = '3.07 ~ 3.14';
            } else if (percentage >= 84) {
                calculatedGPA = '2.98 ~ 3.06';
            } else if (percentage >= 83) {
                calculatedGPA = '2.90 ~ 2.97';
            } else if (percentage >= 82) {
                calculatedGPA = '2.81 ~ 2.89';
            } else if (percentage >= 81) {
                calculatedGPA = '2.72 ~ 2.80';
            } else if (percentage >= 80) {
                calculatedGPA = '2.64 ~ 2.71';
            } else if (percentage >= 79) {
                calculatedGPA = '2.56 ~ 2.63';
            } else if (percentage >= 78) {
                calculatedGPA = '2.48 ~ 2.55';
            } else if (percentage >= 77) {
                calculatedGPA = '2.40 ~ 2.47';
            } else if (percentage >= 76) {
                calculatedGPA = '2.32 ~ 2.39';
            } else if (percentage >= 75) {
                calculatedGPA = '2.24 ~ 2.31';
            } else if (percentage >= 74) {
                calculatedGPA = '2.16 ~ 2.23';
            } else if (percentage >= 73) {
                calculatedGPA = '2.08 ~ 2.15';
            } else if (percentage >= 72) {
                calculatedGPA = '2.00 ~ 2.07';
            } else if (percentage >= 71) {
                calculatedGPA = '1.92 ~ 1.99';
            } else if (percentage >= 70) {
                calculatedGPA = '1.84 ~ 1.91';
            } else if (percentage >= 69) {
                calculatedGPA = '1.75 ~ 1.83';
            } else if (percentage >= 68) {
                calculatedGPA = '1.67 ~ 1.74';
            } else if (percentage >= 67) {
                calculatedGPA = '1.59 ~ 1.66';
            } else if (percentage >= 66) {
                calculatedGPA = '1.51 ~ 1.58';
            } else if (percentage >= 65) {
                calculatedGPA = '1.43 ~ 1.50';
            } else if (percentage >= 64) {
                calculatedGPA = '1.35 ~ 1.42';
            } else if (percentage >= 63) {
                calculatedGPA = '1.26 ~ 1.34';
            } else if (percentage >= 62) {
                calculatedGPA = '1.18 ~ 1.25';
            } else if (percentage >= 61) {
                calculatedGPA = '1.09 ~ 1.17';
            } else if (percentage >= 60) {
                calculatedGPA = '1.00 ~ 1.08';
            } else {
                calculatedGPA = '0.00 ~ 0.99 (Fail)';
            }
            setConvertedGPA(calculatedGPA);
            setShowResult(true);
            setError(null);
        } else {
            setError('Enter a valid percentage between 60 and 100');
            setShowResult(false);
        }
    };
    return (
        <div>
            <div className="row">
                <div className="col-sm-12 col-md-7 calculatorStyle">
                    <div className="p-3 mb-2 bg-success text-white">
                        <h2 style={{ fontSize: '16px' }}>Convert 100-Point Scale to 4-Point GPA</h2>
                    </div>
                    <hr />
                    <div className="form-group d-flex align-items-center">
                        <b><label  htmlFor='originalPercentage'>Percentage:</label></b>
                        <input
                            type="text"
                            value={originalPercentage}
                            id="originalPercentage"
                            onChange={(e) => setOriginalPercentage(e.target.value)}
                            className='form-control'
                            style={{ width: '200px', marginRight: '4px' }}
                        />
                    </div>
                    <button className="btn btn-success mt-3" onClick={handleCalculateClick}>
                        Calculate
                    </button>
                    <br />
                </div>
            </div>
            <br />
            <div className="row">
                <div className="col-sm-12 col-md-7">
                    {error && <div className="alert alert-warning"><b><u>Error:</u></b> {error}</div>}
                    {showResult && (
                        <div style={{ fontSize: '17px' }} className=" bg-light bg-gradient text-dark">
                            <div className="p-3 bg-success bg-gradient text-white">
                                <strong>Results:</strong>
                            </div>
                            <b>GPA Range: {convertedGPA}</b>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
export default Shared100toGPA;
